import { createContext } from "react";

export const PositionContext = createContext();
export const ContactContext = createContext();
export const ProjectContext = createContext();
export const ReviewContext = createContext();
export const ConfigurationContext = createContext();